import React from 'react';
import '../css/footer.css';

const Footer = () => {
  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="footer-cta pt-5 pb-5">
            <div className="row">
              <div className="col-xl-4 col-md-4 mb-30">
                <div className="single-cta">
                  <i className="fa fa-map-marker"></i>
                  <div className="cta-text">
                    <h4>Find us</h4>
                    <span>   A-36 Ram Vihar Colony Sector-14 Indira Nagar Lucknow</span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-4 mb-30">
                <div className="single-cta">
                  <i className="fa fa-phone"></i>
                  <div className="cta-text">
                    <h4>Call us</h4>
                    <span>+91 8052636431</span>
                    <span>+91 6387461923</span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-4 mb-30">
                <div className="single-cta">
                  <i className="fa fa-envelope"></i>
                  <div className="cta-text">
                    <h4>Mail us</h4>
                    <span>viv571998@gmail.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-content pt-5 pb-5">
            <div className="row">
              <div className="col-xl-4 col-lg-4 mb-50">
                <div className="footer-widget">
                  <div className="footer-logo">
                    <a href="index.html">
                      <span> HEALTH CLINIC</span>

                    </a>
                  </div>
                  <div className="footer-text">
                    <p>
                      Welcome to our Health Clinic, where we offer expert care from experienced physicians and dentists. Our clinic has been a trusted provider of quality healthcare for the community, delivering comprehensive services in both general health and dental care.
                    </p>
                  </div>
                  <div className="footer-social-icon">
                    <span>Follow us</span>
                    <a href="#"><i className="fa fa-facebook-f facebook-bg"></i></a>
                    <a href="#"><i className="fa fa-twitter twitter-bg"></i></a>
                    <a href="#"><i className="fa fa-instagram google-bg"></i></a>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
                <div className="footer-widget">
                  <div className="footer-widget-heading">
                    <h3>Treatment </h3>
                  </div>
                  <ul>
                    <li><a href="#">General Medicine</a></li>
                    <li><a href="#">Emergency Care</a></li>
                    <li><a href="#">Preventive Care</a></li>
                    <li><a href="#">General Dentistry</a></li>
                    <li><a href="#">Cosmetic Dentistry</a></li>
                    <li><a href="#">Orthodontics</a></li>


                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
                <div className="footer-widget">

                  <div className="subscribe-form">
                    <div className="footer-widget-heading">
                      <h3>Useful Links</h3>
                    </div>
                    <ul>
                      <li><a href="#">Home</a></li>
                      <li><a href="#">About</a></li>
                      <li><a href="#">Services</a></li>
                      <li><a href="#">Gallery</a></li>


                    </ul>
                    <h3>Timing </h3>
                    <p> Monday :  Saturday: 06 pm 10:00 pm   </p>

                    <p> Sunday Morning  :   09 am  to 01:00 pm   </p>
                    <p> Sunday Evening   :   07 pm  to 09:00 pm   </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-area">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 text-center text-lg-left">
                <div className="copyright-text">
                  <p>
                    Copyright &copy; 2024, All Rights Reserved <a href="">Creative Digital World</a>
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 d-none d-lg-block text-right">
                <div className="footer-menu">
                  <ul>
                    <li><a href="#">Home</a></li>
                    <li><a href="#">Terms</a></li>
                    <li><a href="#">Privacy</a></li>
                    <li><a href="#">Policy</a></li>
                    <li><a href="#">Contact</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div class="whatsapp-btn">
  <a href="https://wa.me/918052636431" target="_blank">
    <i class="fa fa-whatsapp"></i>
  </a>
</div>

    </>
  );
};

export default Footer;
